
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"leadApprovalSheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentProposal"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LeadCurrentProposalInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"movableSecurities"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MovableSecurityInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"immovableSecurities"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImmovableSecurityInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approvalAmount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"termsOffered"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCovenants"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proposedFees"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leadApprovalSheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}}},{"kind":"Argument","name":{"kind":"Name","value":"currentProposal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentProposal"}}},{"kind":"Argument","name":{"kind":"Name","value":"movableSecurities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"movableSecurities"}}},{"kind":"Argument","name":{"kind":"Name","value":"immovableSecurities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"immovableSecurities"}}},{"kind":"Argument","name":{"kind":"Name","value":"approvalAmount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approvalAmount"}}},{"kind":"Argument","name":{"kind":"Name","value":"termsOffered"},"value":{"kind":"Variable","name":{"kind":"Name","value":"termsOffered"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherCovenants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCovenants"}}},{"kind":"Argument","name":{"kind":"Name","value":"proposedFees"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proposedFees"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"las"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadApprovalSheetFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"statusLogsList"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":875}};
    doc.loc.source = {"body":"#import \"../fragments/LeadApprovalSheetFragment.graphql\"\n\nmutation leadApprovalSheet (\n  $customerId: Int!\n  $startedAt: String!\n  $companyName: String!\n  $currentProposal: [LeadCurrentProposalInput]\n  $movableSecurities: [MovableSecurityInput]\n  $immovableSecurities: [ImmovableSecurityInput]\n  $approvalAmount: Float!\n  $termsOffered: String!\n  $otherCovenants: String\n  $proposedFees: String!\n) {\n  leadApprovalSheet (\n    customerId: $customerId\n    startedAt: $startedAt\n    companyName: $companyName\n    currentProposal: $currentProposal\n    movableSecurities: $movableSecurities\n    immovableSecurities: $immovableSecurities\n    approvalAmount: $approvalAmount\n    termsOffered: $termsOffered\n    otherCovenants: $otherCovenants\n    proposedFees: $proposedFees\n  ) {\n    id\n    name\n    las {\n      ...LeadApprovalSheetFields\n    }\n    statusLogsList\n    status\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/LeadApprovalSheetFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["leadApprovalSheet"] = oneQuery(doc, "leadApprovalSheet");
        



//////////////////
// WEBPACK FOOTER
// ./src/graphql/mutations/leadApprovalSheetMutation.graphql
// module id = 1460
// module chunks = 0